window.MarketMapModeSwitching = (function () {
    const CACHE_KEY = 'mmap_view_mode';

    function _getCache() {
        try {
            return (typeof getCacheItem === 'function' ? getCacheItem(CACHE_KEY) : null) || '2d';
        } catch (e) { return '2d'; }
    }

    function _setCache(mode) {
        try {
            if (typeof setCacheItem === 'function') {
                const exp = typeof CACHE_EXPIRATION !== 'undefined' ? CACHE_EXPIRATION.PERSISTENT : 5256000;
                setCacheItem(CACHE_KEY, mode, exp);
            }
        } catch (e) { console.warn('Failed to set cache item', e); }
    }

    function _getVisualizer() {
        const el = document.getElementById('stock-3d-cube');
        return el && el.components && el.components['stock-cube-visualizer'];
    }

    function _getWrapper() {
        return document.getElementById('stock-3d-cube-wrapper');
    }

    function _getStocksFromCurrentData(visualizer) {
        const cd = visualizer.currentData;
        if (!cd || !cd.intervals) return null;
        const times = Object.keys(cd.intervals).sort();
        if (!times.length) return null;
        const lastStocks = cd.intervals[times[times.length - 1]] || [];
        return lastStocks.map(s => Object.assign({}, s, (cd.stockInfo || {})[s.ticker] || {}));
    }

    function _emitModeChanged(visualizer, mode) {
        const sceneEl = visualizer.el && visualizer.el.sceneEl;
        if (sceneEl) sceneEl.emit('mmap-mode-changed', { mode });
    }

    function getCurrentMode() {
        return _getCache();
    }

    function switchTo3D(optVisualizer) {
        const visualizer = optVisualizer || _getVisualizer();
        if (!visualizer) { console.warn('[MmapMode] No visualizer found'); return; }
        if (visualizer.mmapViewMode === '3d') return;

        const isVR = visualizer.platformConfig && visualizer.platformConfig.platform === 'vr';
        const wrapper = _getWrapper();

        visualizer.mmapViewMode = '3d';
        _setCache('3d');
        _emitModeChanged(visualizer, '3d');

        const targetScale = isVR ? '0.85 0.85 0.85' : '1 1 1';

        if (typeof visualizer.calculateBehavioralFlags === 'function') {
            visualizer.calculateBehavioralFlags();
        }

        if (wrapper) {
            let rotY = isVR ? 45 : 0;
            if (isVR) {
                const cp = document.querySelector('#large-center-panel');
                if (cp) {
                    const rot = cp.getAttribute('rotation');
                    rotY = -(typeof rot === 'object' ? (rot.y || 0) : (parseFloat(String(rot).split(' ')[1]) || 0));
                }
            }
            
            const _to3D = isVR ? `30 ${rotY} 0` : '30 0 0';
            const _from3D = (() => {
                const curRot = wrapper.getAttribute('rotation');
                if (!curRot) return undefined;
                const rx = typeof curRot === 'object' ? (curRot.x || 0) : parseFloat(String(curRot).split(' ')[0]);
                const ry = typeof curRot === 'object' ? (curRot.y || 0) : parseFloat(String(curRot).split(' ')[1]);
                const rz = typeof curRot === 'object' ? (curRot.z || 0) : parseFloat(String(curRot).split(' ')[2]);
                return `${rx} ${ry} ${rz}`;
            })();

            wrapper.setAttribute('animation__mmrot', {
                property: 'rotation',
                from: _from3D,
                to: _to3D,
                dur: 500,
                easing: 'easeInOutQuad'
            });

            if (isVR) {
                wrapper.setAttribute('animation__mmscale', {
                    property: 'scale',
                    to: targetScale,
                    dur: 500,
                    easing: 'easeInOutQuad'
                });
                wrapper.setAttribute('animation__mmpos', {
                    property: 'position',
                    to: '0 0 0',
                    dur: 500,
                    easing: 'easeInOutQuad'
                });
            }
        }

        setTimeout(() => {
            if (visualizer.currentData && visualizer.currentData.intervals) {
                try {
                    visualizer._mmapGrowDelayOffset = 200;
                    window.MarketMapSharedRendering.renderMarketMap(visualizer, visualizer.currentData || null);
                } catch (e) {
                    visualizer._mmapGrowDelayOffset = 0;
                    console.warn('[MmapMode] renderMarketMap error:', e);
                }
            }

            setTimeout(() => {
                if (typeof visualizer.updateBillboards === 'function') {
                    visualizer.updateBillboards(true);
                }
                if (window.StockCubeCore && typeof window.StockCubeCore.recalcLabelPositions === 'function') {
                    window.StockCubeCore.recalcLabelPositions.call(visualizer);
                }
            }, 50);
        }, 500);
    }

    function _collapseCurrent3DBars(visualizer) {
        if (!visualizer.stockBars || visualizer.stockBars.size === 0) return;
        const DUR = 350;
        visualizer.stockBars.forEach(entry => {
            const bar = entry.bar;
            if (!bar || !bar.parentNode) return;
            const pos = bar.getAttribute('position');
            const px = typeof pos === 'object' ? pos.x : parseFloat(String(pos).split(' ')[0]);
            const py = typeof pos === 'object' ? pos.y : parseFloat(String(pos).split(' ')[1]);
            const pz = typeof pos === 'object' ? pos.z : parseFloat(String(pos).split(' ')[2]);
            bar.setAttribute('animation__collapse', { property: 'scale', from: '1 1 1', to: '1 0.001 1', dur: DUR, easing: 'easeInQuad' });
            bar.setAttribute('animation__sink',     { property: 'position', from: `${px} ${py} ${pz}`, to: `${px} 0 ${pz}`, dur: DUR, easing: 'easeInQuad' });
            if (entry.primaryLabel && entry.primaryLabel.parentNode) {
                entry.primaryLabel.setAttribute('animation__fadeout', { property: 'opacity', from: 1, to: 0, dur: 180, easing: 'linear' });
            }
        });
    }

    function switchTo2D(optVisualizer) {
        const visualizer = optVisualizer || _getVisualizer();
        if (!visualizer) { console.warn('[MmapMode] No visualizer found'); return; }
        if (!visualizer.mmapViewMode || visualizer.mmapViewMode === '2d') return;

        const has3DBars = visualizer.stockBars && visualizer.stockBars.size > 0;
        if (has3DBars) _collapseCurrent3DBars(visualizer);

        const COLLAPSE_DUR  = has3DBars ? 250 : 0;
        const ROTATE_DUR    = 500;
        const RENDER_DELAY  = COLLAPSE_DUR + ROTATE_DUR + 50;

        const isVR = visualizer.platformConfig && visualizer.platformConfig.platform === 'vr';
        const wrapper = _getWrapper();

        visualizer.mmapViewMode = '2d';
        _setCache('2d');
        _emitModeChanged(visualizer, '2d');

        const _movingEl = isVR ? document.querySelector('[main-elements-moving]') : null;
        const _movingComp = _movingEl && _movingEl.components && _movingEl.components['main-elements-moving'];
        const _isCenterSlot = !_movingComp || _movingComp.data.currentStep === 0;

        const targetScale = isVR ? (_isCenterSlot ? '0.9 0.9 0.9' : '0.75 0.65 0.75') : '1 1 1';

        if (typeof visualizer.calculateBehavioralFlags === 'function') {
            visualizer.calculateBehavioralFlags();
        }

        if (wrapper) {
            let rotY = isVR ? 45 : 0;
            if (isVR) {
                const cp = document.querySelector('#large-center-panel');
                if (cp) {
                    const rot = cp.getAttribute('rotation');
                    rotY = -(typeof rot === 'object' ? (rot.y || 0) : (parseFloat(String(rot).split(' ')[1]) || 0));
                }
            }
            const wrapperRotY = (isVR && !_isCenterSlot) ? 0 : rotY;

            const default3DRot = isVR ? `30 ${wrapperRotY} 0` : '30 0 0';
            wrapper.setAttribute('rotation', default3DRot);

            const rot2D = isVR ? `90 ${wrapperRotY} 0` : '90 0 0';
            wrapper.setAttribute('animation__mmrot', {
                property: 'rotation',
                from: default3DRot,
                to: rot2D,
                dur: ROTATE_DUR,
                delay: COLLAPSE_DUR,
                easing: 'easeInOutQuad'
            });

            if (isVR) {
                wrapper.setAttribute('animation__mmscale', {
                    property: 'scale',
                    to: targetScale,
                    dur: ROTATE_DUR,
                    delay: COLLAPSE_DUR,
                    easing: 'easeInOutQuad'
                });

                const MMAP_Y_CENTER = 0.11;
                const MMAP_Y_SIDE   = 0.30;
                if (_isCenterSlot) {
                    wrapper.setAttribute('animation__mmpos', {
                        property: 'position',
                        to: `0 ${MMAP_Y_CENTER} 0`,
                        dur: ROTATE_DUR,
                        delay: COLLAPSE_DUR,
                        easing: 'easeInOutQuad'
                    });
                } else {
                    const _cpEl = document.querySelector('#large-center-panel');
                    const _cpPos = _cpEl && _cpEl.getAttribute('position');
                    const _cpX = _cpPos ? (typeof _cpPos === 'object' ? _cpPos.x : parseFloat(String(_cpPos).split(' ')[0])) : 0;
                    const _goRight = _cpX > 0;
                    const _tX = _goRight ? 0.08 : 0.04;
                    const _tZ = _goRight ? 0 : 0.04;
                    wrapper.setAttribute('animation__mmpos', {
                        property: 'position',
                        to: `${_tX} ${MMAP_Y_SIDE} ${_tZ}`,
                        dur: ROTATE_DUR,
                        delay: COLLAPSE_DUR,
                        easing: 'easeInOutQuad'
                    });
                }
            }
        }

        if (!isVR) {
            if (visualizer._mmapCameraZBefore3D !== undefined) {
                const cam = document.getElementById('camera');
                if (cam) {
                    const camPos = cam.getAttribute('position') || { x: 0, y: 2.75, z: 2 };
                    const cx = typeof camPos === 'string' ? parseFloat(camPos.split(' ')[0]) : (camPos.x || 0);
                    const cy = typeof camPos === 'string' ? parseFloat(camPos.split(' ')[1]) : (camPos.y || 2.75);
                    const savedZ = visualizer._mmapCameraZBefore3D;
                    cam.setAttribute('animation__camZ', {
                        property: 'position',
                        to: `${cx} ${cy} ${savedZ}`,
                        dur: ROTATE_DUR,
                        delay: COLLAPSE_DUR,
                        easing: 'easeInOutQuad'
                    });
                }
                visualizer._mmapCameraZBefore3D = undefined;
            }
            visualizer.mmap2DPosition = null;
        }

        setTimeout(() => {
            try {
                visualizer._mmapRepoAnimDur = 400;
                window.MarketMapSharedRendering.renderMarketMap(visualizer, visualizer.currentData || null);
            } catch (e) {
                visualizer._mmapRepoAnimDur = 0;
                console.warn('[MmapMode] renderMarketMap error:', e);
            }
        }, RENDER_DELAY);
    }

    function applyModeInstant(mode, optVisualizer) {
        const visualizer = optVisualizer || _getVisualizer();
        if (!visualizer) return;

        visualizer.mmapViewMode = mode;

        if (typeof visualizer.calculateBehavioralFlags === 'function') {
            visualizer.calculateBehavioralFlags();
        }

        const isVR = visualizer.platformConfig && visualizer.platformConfig.platform === 'vr';
        const wrapper = _getWrapper();

        if (mode === '3d') {
            if (wrapper) {
                let rotY = isVR ? 45 : 0;
                if (isVR) {
                    const cp = document.querySelector('#large-center-panel');
                    if (cp) {
                        const rot = cp.getAttribute('rotation');
                        rotY = -(typeof rot === 'object' ? (rot.y || 0) : (parseFloat(String(rot).split(' ')[1]) || 0));
                    }
                }
                wrapper.setAttribute('rotation', isVR ? `30 ${rotY} 0` : '30 0 0');
                if (isVR) {
                    wrapper.setAttribute('position', '0 0 0');
                }
            }
        }
        _emitModeChanged(visualizer, mode);
    }

    return { getCurrentMode, switchTo3D, switchTo2D, applyModeInstant };
})();

(function initVRUIIntegration() {
    if (typeof document === 'undefined') return;

    let _vrMmapViewBtn = null;
    const VR_MMAP_VIEW_BTN_POSITION = '-0.550 -0.790 0.030';

    function _updateVRUIForMmap(isMmap) {
        console.log('[VR UI Mmap] Calling _updateVRUIForMmap, isMmap:', isMmap);
        const timelineEntity = document.querySelector('a-entity#timeline');
        const dockEntity = document.getElementById('dock');
        if (!timelineEntity || !dockEntity) return;

        if (isMmap) {
            timelineEntity.setAttribute('scale', '0 0 0');
            timelineEntity.setAttribute('position', '0 -999 0');
            timelineEntity.setAttribute('visible', false);
            if (timelineEntity.object3D) timelineEntity.object3D.visible = false;
        } else {
            timelineEntity.setAttribute('scale', '.6 .6 .6');
            timelineEntity.setAttribute('position', '-0.33 -0.72 0');
            timelineEntity.setAttribute('visible', true);
            if (timelineEntity.object3D) timelineEntity.object3D.visible = true;
        }
        
        if (isMmap) {
            const raycastables = timelineEntity.querySelectorAll('[data-raycastable]');
            raycastables.forEach(el => el.classList.add('mmap-hidden-raycastable'));
            timelineEntity.querySelectorAll('.mmap-hidden-raycastable').forEach(el => el.removeAttribute('data-raycastable'));
            timelineEntity.removeAttribute('data-raycastable');
        } else {
            timelineEntity.querySelectorAll('.mmap-hidden-raycastable').forEach(el => {
                el.setAttribute('data-raycastable', '');
                el.classList.remove('mmap-hidden-raycastable');
            });
            timelineEntity.setAttribute('data-raycastable', '');
        }

        const currentTimeDateEl = document.querySelector('#current-time-date');
        if (currentTimeDateEl) {
            currentTimeDateEl.setAttribute('visible', true);
            if (currentTimeDateEl.object3D) currentTimeDateEl.object3D.visible = true;
        }

        if (isMmap) {
            const currentMode = window.MarketMapModeSwitching.getCurrentMode();
            const label = currentMode === '3d' ? '2D View' : '3D View';
            const icon = currentMode === '3d' ? 'vr-assets/d2view.png' : 'vr-assets/d3view.png';
            const showBuildings = currentMode === '2d';

            if (!_vrMmapViewBtn) {
                const btn = document.createElement('a-entity');
                btn.setAttribute('id', 'mmap-vr-mode-btn');
                btn.setAttribute('ui-button', {
                    label: label,
                    type: 'image-text',
                    image: icon,
                    width: 0.50,
                    height: 0.12,
                    depth: 0.02,
                    radius: 0.02,
                    preferredFontSize: 0.05,
                    colorType: 'primary',
                });

                btn.setAttribute('scale', '.6 .6 .6');
                btn.setAttribute('position', VR_MMAP_VIEW_BTN_POSITION);
                btn.setAttribute('rotation', '0 0 -45');

                dockEntity.appendChild(btn);
                _vrMmapViewBtn = btn;

                btn.addEventListener('click', () => {
                    const mode = window.MarketMapModeSwitching.getCurrentMode();
                    if (mode === '3d') {
                        window.MarketMapModeSwitching.switchTo2D();

                        if(window.gtag) gtag('event', `VR_TopNav_Marketmap3D`);
                    } else {
                        window.MarketMapModeSwitching.switchTo3D();

                        if(window.gtag) gtag('event', `VR_TopNav_Marketmap2D`);
                    }
                });
            } else {
                _vrMmapViewBtn.setAttribute('ui-button', 'label', label);
                _vrMmapViewBtn.setAttribute('ui-button', 'image', icon);
                _vrMmapViewBtn.setAttribute('ui-button', 'width', 0.50);
                _vrMmapViewBtn.setAttribute('ui-button', 'height', 0.12);
                _vrMmapViewBtn.setAttribute('ui-button', 'preferredFontSize', 0.05);

                _vrMmapViewBtn.setAttribute('position', VR_MMAP_VIEW_BTN_POSITION);
                _vrMmapViewBtn.setAttribute('visible', true);
                if (_vrMmapViewBtn.object3D) _vrMmapViewBtn.object3D.visible = true;
            }
            _vrMmapViewBtn.setAttribute('data-raycastable', '');
        } else {
            if (_vrMmapViewBtn) {
                _vrMmapViewBtn.setAttribute('visible', false);
                if (_vrMmapViewBtn.object3D) _vrMmapViewBtn.object3D.visible = false;
                _vrMmapViewBtn.removeAttribute('data-raycastable');
            }
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        const sceneEl = document.querySelector('a-scene');
        if (sceneEl) {
            sceneEl.addEventListener('chart-type-changed', (e) => {
                const isMmap = e.detail && e.detail.action === 'mmap';
                _updateVRUIForMmap(isMmap);
            });

            sceneEl.addEventListener('mmap-mode-changed', (e) => {
                const mode = (e.detail && e.detail.mode) || '2d';
                console.log('[VR UI Mmap] mmap-mode-changed event received, mode:', mode);
                const isVisible = _vrMmapViewBtn && (_vrMmapViewBtn.getAttribute('visible') === 'true' || (_vrMmapViewBtn.object3D && _vrMmapViewBtn.object3D.visible));
                if (_vrMmapViewBtn && isVisible) {
                    const label = mode === '3d' ? '2D View' : '3D View';
                    const icon = mode === '3d' ? 'vr-assets/d2view.png' : 'vr-assets/d3view.png';
                    console.log('[VR UI Mmap] Updating button to:', label);
                    _vrMmapViewBtn.setAttribute('ui-button', 'label', label);
                    _vrMmapViewBtn.setAttribute('ui-button', 'image', icon);
                }

            });

            setTimeout(() => {
                try {
                    const cached = typeof getCacheItem !== 'undefined' ? getCacheItem('lastChartType') : null;
                    if (cached && cached.startsWith('mmap')) {
                        _updateVRUIForMmap(true);
                    }
                } catch (e) {}
            }, 300);
        }
    });
})();
